import { IconButton, Typography } from "@mui/material"
import { EditOutlined } from "@mui-symbols-material/w300"
import React from "react"

interface ExpandedLocationRowContactsTitleProps {
  title: string
  label: string
  onClick: () => void
}

const ContactCardTitle: React.FC<ExpandedLocationRowContactsTitleProps> = ({ title, label, onClick }) => {
  return (
    <Typography variant='body2' className='text-base text-primary'>
      {title}
      <IconButton size='small' onClick={onClick} className='ml-4' aria-label={label}>
        <EditOutlined className='h-5' />
      </IconButton>
    </Typography>
  )
}

export default ContactCardTitle
